/**
 * dirty — the one-line dirty flag for HUD elements.
 *
 * A HUD element that rebuilds PIXI.Graphics every frame (`clear()` + shapes +
 * `fill()`) re-tessellates geometry 60× a second for pixels that did not
 * change. Instead, each update computes a small *view model* — the handful of
 * values the drawing actually depends on — and only redraws when it differs
 * from the last frame's.
 *
 *   const vm = { itemId, stack, active };
 *   if (changed(slot, 'body', vm)) { slot.background.clear(); … }
 *
 * The view model must be JSON-serialisable and must contain *everything* the
 * redraw reads (a value you forget is a value that will not refresh).
 */

/**
 * @param {object} target - the element/slot the view model belongs to
 * @param {string} key - which drawing on the target (an element may have several)
 * @param {*} viewModel - JSON-serialisable snapshot of the inputs to that drawing
 * @returns {boolean} true when viewModel differs from the last accepted one for (target, key)
 */
export function changed(target, key, viewModel) {
  const json = JSON.stringify(viewModel);
  const store = target.__viewModels || (target.__viewModels = {});
  if (store[key] === json) return false;
  store[key] = json;
  return true;
}

/** Forget every stored view model on a target (after a rebuild/reset). */
export function invalidate(target) {
  if (target) target.__viewModels = undefined;
}
